'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPause = function IoPause(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 34.1c0 0.5-0.4 0.9-0.9 0.9h-5.7c-0.5 0-0.9-0.4-0.9-0.9v-28.2c0-0.5 0.4-0.9 0.9-0.9h5.7c0.5 0 0.9 0.4 0.9 0.9v28.2z m11.6-29.1c0.5 0 0.9 0.4 0.9 0.9v28.2c0 0.5-0.4 0.9-0.9 0.9h-5.7c-0.5 0-0.9-0.4-0.9-0.9v-28.2c0-0.5 0.4-0.9 0.9-0.9h5.7z' })
        )
    );
};

exports.default = IoPause;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/pause.js
// module id = 2855
// module chunks = 168707334958949